import axios from 'axios';
import { API_RESULT_CD, BAD_REQUEST, CommonResult, createApiRequestUrl, FORBIDDEN, INTERNAL_SERVER_ERROR, NOT_FOUND, OK } from '../Common';
import { API_EXCEPTION_MSG } from '../../Common';

const URL = createApiRequestUrl('stores');

export interface StoresApiRequest {
  classCd: string;
  postCd: string;
  userId: string;
}

export interface StoreInfo {
  ordcstmCd: string;
  agencyCd: string;
  commonStoreCd: string;
  companyCfc: number;
  longName: string;
  shortName: string;
  brandType: string;
  areaCode: number;
  prefCd: string;
  cityCd: string;
  wideAreaBillCd?: string;
  wideAreaBillCdLongNm?: string;
  billcstmCd?: string;
  billcstmLongNm?: string;
  corporateNumber?: string;
  corporateNm?: string;
  mngcstmCd?: string;
  selectedForFilter?: boolean;
  kanaName: string;
}

export interface StoresApiResponse {
  result: CommonResult;
  stores?: StoreInfo[];
}

export async function storesApi(request: StoresApiRequest): Promise<StoresApiResponse> {
  try {
    const response = await axios.get<StoresApiResponse>(`${URL}?${[`classCd=${request.classCd}`, `postCd=${request.postCd}`].join('&')}`);
    const status = response.status;

    switch (status) {
      case OK.status:
        return response.data;
      case INTERNAL_SERVER_ERROR.status:
        throw new Error(INTERNAL_SERVER_ERROR.message);
      case BAD_REQUEST.status:
        throw new Error(BAD_REQUEST.message);
      case NOT_FOUND.status:
        throw new Error(NOT_FOUND.message);
      case FORBIDDEN.status:
        throw new Error(FORBIDDEN.message);

      default:
        throw new Error('APIとの接続に失敗しました');
    }
  } catch (error) {
    return {
      result: {
        jobDateTime: '',
        resultCd: API_RESULT_CD.ERROR,
        resultMessageDtoList: [
          {
            resultMessageCd: '9999',
            resultMessage: `${API_EXCEPTION_MSG}  エラー内容:[${error}]`,
          },
        ],
      },
    };
  }
}
